/**
 * Get or create a unique visitor ID for analytics tracking
 * The visitor ID is stored in localStorage and persists across sessions
 * @returns {string} A unique visitor ID (UUID v4)
 */
export const getVisitorId = () => {
  const VISITOR_ID_KEY = 'calendiary_visitor_id';

  // Try to get existing visitor ID from localStorage
  let visitorId = localStorage.getItem(VISITOR_ID_KEY);

  // If no visitor ID exists, create a new one
  if (!visitorId) {
    // Generate a UUID v4
    visitorId = crypto.randomUUID();

    // Store it in localStorage for future visits
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }

  return visitorId;
};
